var render, staticRenderFns
import script from "./JsxRender.vue?vue&type=script&lang=js&"
export * from "./JsxRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f52311')) {
      api.createRecord('73f52311', component.options)
    } else {
      api.reload('73f52311', component.options)
    }
    
  }
}
component.options.__file = "src/components/common/JsxRender.vue"
export default component.exports